import { AlertCircle, CheckCircle2, Info, Loader2, X } from "lucide-react";
import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const ICONE = "h-4 w-4";

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      offset={84}
      closeButton
      icons={{
        success: <CheckCircle2 className={`${ICONE} text-[#075E54] dark:text-[#25D366]`} />,
        error: <AlertCircle className={`${ICONE} text-[#5B0A0D] dark:text-[#C87484]`} />,
        warning: <Info className={`${ICONE} text-[#7A2235] dark:text-[#C87484]`} />,
        info: <Info className={`${ICONE} text-[#7A2235] dark:text-[#C87484]`} />,
        loading: <Loader2 className={`${ICONE} animate-spin text-muted-foreground`} />,
        close: <X className="h-3.5 w-3.5" />,
      }}
      toastOptions={{
        classNames: {
          toast:
            "group toast !items-start !gap-2.5 !rounded-lg !border !border-l-[3px] !border-border !border-l-[#075E54] dark:!border-l-[#25D366] !bg-card !py-2.5 !pl-3 !pr-9 !text-foreground !shadow-lg",
          success: "!border-l-[#075E54] dark:!border-l-[#25D366]",
          error: "!border-l-[#5B0A0D] dark:!border-l-[#C87484] [&_[data-title]]:!text-[#5B0A0D] dark:[&_[data-title]]:!text-[#C87484]",
          warning: "!border-l-[#7A2235] dark:!border-l-[#C87484]",
          info: "!border-l-[#7A2235] dark:!border-l-[#C87484]",
          loading: "!border-l-border",
          icon: "!mt-px !ml-0 !mr-0",
          title: "!text-[13px] !font-semibold !leading-snug",
          description: "!text-[12px] !leading-snug !text-muted-foreground",
          closeButton:
            "!left-auto !right-2 !top-2 !transform-none !border-0 !bg-transparent !text-muted-foreground hover:!text-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
